module.exports = __webpack_public_path__ + "media/images/real-trust-b81e65d6bb39a7d2dbf9117b885997d1.png";